import React from 'react'
import { Carousel } from 'react-bootstrap'
import { FaStar } from 'react-icons/fa'


export default function Error() {
    return (
        <>
            <div className="container ">
                <div className="row mx-0">
                    <div className="col-lg-6 order-lg-0 order-1 mt-lg-5 home-left  ">

                        <div className="card  w-100 mt-lg-5 p-2">
                            <div className="card-body p-4">
                                <div className="d-flex flex-column align-items-center">
                                    <h6 className="pt-3">Maintenance in Progress</h6>
                                    <img src={process.env.PUBLIC_URL + '/assets/images/logo.png'} className="my-4" style={{ width: "100px" }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 home-img d-flex order-lg-1 order-0">
                        <img src={process.env.PUBLIC_URL + '/assets/images/cartoon.png'} alt="" />
                    </div>
                </div>
            </div>
        </>
    )
}
